// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-menu .v-tabs-items > .v-window__container > div,\n.right-menu .v-tabs-items > .v-window-item > div,\n.right-menu .v-tabs-items > .v-window__container > .v-window-item > div {\n  height: calc(var(--100vh) - 165px);\n}", ""]);
// Exports
module.exports = exports;
